__turbopack_context__.v({
  "checkbox": "FoNSpG_checkbox",
  "checkbox__input": "FoNSpG_checkbox__input",
  "checkbox__label": "FoNSpG_checkbox__label",
});
